import type { ReactNode } from "react";

type PillTone = "neutral" | "yes" | "no" | "accent" | "warn";

const TONE_CLASS: Record<PillTone, string> = {
  neutral: "pill",
  yes: "pill pill-yes",
  no: "pill pill-no",
  accent: "pill pill-accent",
  warn: "pill pill-warn",
};

interface PillProps {
  tone?: PillTone;
  children: ReactNode;
  className?: string;
}

/** Piccola pill colorata. Stesso pattern di apps/web/. */
export function Pill({ tone = "neutral", children, className = "" }: PillProps) {
  return <span className={`${TONE_CLASS[tone]} ${className}`}>{children}</span>;
}

/** Mappa lo `status` di un market sulla tonalità corretta della pill. */
export function statusToTone(status: string): PillTone {
  switch (status) {
    case "open":
      return "yes";
    case "closed":
    case "pending_resolution":
      return "warn";
    case "resolved":
      return "accent";
    case "cancelled":
      return "no";
    default:
      return "neutral";
  }
}
